package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.stevdza.san.kotlinbs.models.navbar.NavBarInputField
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

@Composable
fun SearchBarWithAddEditCloseIcon(
    showEdit:Boolean=true,
    showDelete:Boolean=true,
    searchFieldWidth:CSSSizeValue<CSSUnit.px> = Dimen.extraSemiMediumEditText ,
    width:CSSSizeValue<CSSUnit.px>?=null,
    onSearchInfo: (String) -> Unit,
    onAddClick: () -> Unit,
    onEditClick:()->Unit={},
    onDeleteClick:()->Unit={},
) {
    Row(
        modifier = Modifier
            .autoResponsiveness()
            .fillMaxWidth()
            .thenIf(
                width!=null,
                Modifier.width(width?:0.px)
            )
            .margin(bottom = Dimen.mediumPadding),
        verticalAlignment = Alignment.Bottom,
    )
    {

        CustomIcon(
            modifier = Modifier ,
            hoveredColor = Theme.PrimaryStatesHover.rgb,
            focusedColor = Theme.PrimaryStatesFocus.rgb,
            iconColor=Theme.PrimaryMain.hex,
            icon = Res.PathIcon.add,
            tooltipText = Strings.current().add,
            onIconClick = {
                onAddClick()
            }
        )
        if (showEdit){
            CustomIcon(
                modifier = Modifier
                    .margin(leftRight = Dimen.semiNormalPadding),
                hoveredColor = Theme.PrimaryStatesHover.rgb,
                focusedColor = Theme.PrimaryStatesFocus.rgb,
                iconColor=Theme.PrimaryMain.hex,
                icon = Res.PathIcon.edit,
                tooltipText = Strings.current().edit,
                onIconClick = {
                    onEditClick()
                }
            )
        }

        if (showDelete){
            CustomIcon(
                hoveredColor = Theme.PrimaryStatesHover.rgb,
                focusedColor = Theme.PrimaryStatesFocus.rgb,
                iconColor=Theme.PrimaryMain.hex,
                icon = Res.PathIcon.delete,
                tooltipText = Strings.current().delete,
                onIconClick = {
                    onDeleteClick()
                }
            )

        }

        Spacer()

        CustomEditText(
            modifier = Modifier,
            label = "",
            marginBottom = 0.px,
            width = searchFieldWidth,
            value = "",
            marginRight = Dimen.smallPadding,
            hasLabelSpace = false,
            endIconPath = Res.PathIcon.searchBox,
            isRequired = false,
            hint = Strings.current().search,
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                onSearchInfo(it)
            },
        )



    }
}